import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import AccountingDocumentNumber from "./AccountingDocumentNumber";

export default class CurrentAccountAndAccountingDocumentsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'current_account': {
                    "customer": {
                        "code": "123",
                        "fantasy_name": "Client123",
                        "business_name": "Client123BN123",
                        "number": "1234",
                        "taxpayer_identification_number": 123,
                        "delivery_sites": [
                            {
                                "name": "DeliverySite123",
                                "address": "Calle123",
                                "city": "CABA"
                            },
                            {
                                "name": "DeliverySite456",
                                "address": "Calle456",
                                "city": "CABA"
                            }
                        ]
                    },
                    "outstanding_balance": {
                        'amount': 10000.00,
                        'currency': "ARS"
                    },
                    "overdue_balance": {
                        'amount': 2500.00,
                        'currency': "ARS"
                    },
                    "unassigned_balance": {
                        'amount': 0.00,
                        'currency': "ARS"
                    },
                    "total_balance": {
                        'amount': 12500.00,
                        'currency': "ARS"
                    },
                    "has_no_overdue_tolerance": false,
                    "judicial_stage": "without_judicial_management"
                },
                'has_pending_judicial_management_request': false,
                'primary_record': {
                    'initial_balance': {'amount': 0.00, 'currency': 'ARS'},
                    'documents_with_running_balance': [
                        {
                            'emission_date': "20-05-2024",
                            'expiration_date': "19-06-2024",
                            'type': 'FC',
                            'type_name': 'Factura',
                            'number': '00012345',
                            'point_of_sale': '12345',
                            'document_label': 'FC 12345-012345',
                            'total': {'amount': 1000.00, 'currency': 'ARS'},
                            'is_credit': false,
                            'is_debit': true,
                            'has_file': true,
                            'balance': {'amount': 1000.00, 'currency': 'ARS'},
                        }
                    ]
                },
                'channel': 'HORECA',
                'payment_term': '30 días',
                'worst_tier': {'code': 'over_90', 'label': '+90'},
                'has_order_with_future_delivery': true,
                'accounting_documents': [
                    {
                        'emission_date': "20-05-2024",
                        'type': 'FC',
                        'point_of_sale': '00012',
                        'number': '00012345',
                        'expiration_date': "20-06-2024",
                        'is_debit': true,
                        'is_credit': false,
                        'group': 'invoices',
                        'total': {
                            'amount': 1000.00,
                            'currency': 'ARS'
                        },
                        'applied_amount': {'amount': 400.00, 'currency': 'ARS'},
                        'pending_amount': {'amount': 600.00, 'currency': 'ARS'},
                        'overdue_days': 5,
                        'status': {'code': '1_to_7', 'label': '0 a 7 días'},
                        'applications': [
                            {
                                'debit_document': {
                                    'type': 'FC',
                                    'point_of_sale': '00012',
                                    'number': '00012345',
                                    'issue_date': '20-05-2024',
                                },
                                'applied_document': {
                                    'type': 'RC',
                                    'point_of_sale': '00002',
                                    'number': '00002233',
                                    'issue_date': '18-05-2024',
                                },
                                'applied_amount': {'amount': 400.00, 'currency': 'ARS'},
                            },
                            {
                                'debit_document': {
                                    'type': 'FC',
                                    'point_of_sale': '00012',
                                    'number': '00012345',
                                    'issue_date': '20-05-2024',
                                },
                                'applied_document': {
                                    'type': 'CG',
                                    'point_of_sale': '',
                                    'number': '00778899',
                                    'issue_date': '18-05-2024',
                                },
                                'applied_amount': {'amount': 120.00, 'currency': 'ARS'},
                            }
                        ],
                    },
                    {
                        'emission_date': "20-05-2024",
                        'type': 'RC',
                        'point_of_sale': '00002',
                        'number': '00002233',
                        'is_debit': false,
                        'is_credit': true,
                        'group': 'receipts',
                        'total': {
                            'amount': 400.00,
                            'currency': 'ARS'
                        },
                        'applied_amount': {'amount': 400.00, 'currency': 'ARS'},
                        'unapplied_amount': {'amount': 0.00, 'currency': 'ARS'},
                        'applications': [
                            {
                                'debit_document': {
                                    'type': 'FC',
                                    'point_of_sale': '00012',
                                    'number': '00012345',
                                    'issue_date': '20-05-2024',
                                },
                                'applied_document': {
                                    'type': 'RC',
                                    'point_of_sale': '00002',
                                    'number': '00002233',
                                    'issue_date': '18-05-2024',
                                },
                                'applied_amount': {'amount': 400.00, 'currency': 'ARS'},
                            }
                        ],
                    }],
                'has_overdue_invoices': true
            },
            errors: []
        }
    }

    currentAccount() {
        const currentAccount = this.content().current_account;
        const content = this.content();
        return {
            customer: {
                fantasyName: currentAccount.customer.fantasy_name,
                businessName: currentAccount.customer.business_name,
                taxpayerIdentificationNumber: currentAccount.customer.taxpayer_identification_number,
            },
            outstandingBalance: currentAccount.outstanding_balance,
            overdueBalance: currentAccount.overdue_balance,
            unassignedBalance: currentAccount.unassigned_balance,
            totalBalance: currentAccount.total_balance,
            isHighRisk: currentAccount.has_no_overdue_tolerance,
            judicialStage: currentAccount.judicial_stage,
            channel: content.channel,
            paymentTerm: content.payment_term,
            worstTier: content.worst_tier,
            hasOrderWithFutureDelivery: content.has_order_with_future_delivery,
        }
    }

    primaryRecord() {
        const primaryRecord = this.content().primary_record;
        return {
            initialBalance: primaryRecord.initial_balance,
            documentsWithRunningBalance: primaryRecord.documents_with_running_balance.map(
                documentWithRunningBalance => this._adaptedDocumentWithRunningBalance(documentWithRunningBalance)),
        }
    }

    _adaptedDocumentWithRunningBalance(documentWithRunningBalance) {
        return {
            emissionDate: documentWithRunningBalance.emission_date,
            typeName: documentWithRunningBalance.type_name,
            documentLabel: documentWithRunningBalance.document_label,
            hasFile: documentWithRunningBalance.has_file,
            isDebit: documentWithRunningBalance.is_debit,
            total: documentWithRunningBalance.total,
            balance: documentWithRunningBalance.balance,
        }
    }

    paymentReminder() {
        return {
            hasOverdueInvoices: this.content().has_overdue_invoices,
        }
    }

    hasPendingJudicialManagementRequest() {
        return this.content().has_pending_judicial_management_request;
    }

    accountingDocuments() {
        return this.content().accounting_documents.map(accountingDocument => {
                return {
                    id: `${accountingDocument.type}-${accountingDocument.point_of_sale}-${accountingDocument.number}`,
                    number: accountingDocument.number,
                    pointOfSale: accountingDocument.point_of_sale,
                    emissionDate: accountingDocument.emission_date,
                    type: accountingDocument.type,
                    numberWithPointOfSale: this.adaptNumberWithPointOfSale(accountingDocument.point_of_sale, accountingDocument.number),
                    expirationDate: accountingDocument.expiration_date ?? '-',
                    total: accountingDocument.total,
                    isDebit: accountingDocument.is_debit,
                    isCredit: accountingDocument.is_credit,
                    group: accountingDocument.group,
                    appliedAmount: accountingDocument.applied_amount,
                    pendingAmount: accountingDocument.pending_amount,
                    unappliedAmount: accountingDocument.unapplied_amount,
                    overdueDays: accountingDocument.overdue_days,
                    status: accountingDocument.status,
                    applications: this._adaptedApplicationsOf(accountingDocument),
                }
            }
        )
    }

    _adaptedApplicationsOf(accountingDocument) {
        return accountingDocument.applications.map(application => {
            return {
                debitDocument: this._adaptedAccountingDocumentIdentifier(application.debit_document),
                appliedDocument: this._adaptedAccountingDocumentIdentifier(application.applied_document),
                appliedAmount: application.applied_amount,
            }
        })
    }

    _adaptedAccountingDocumentIdentifier(accountingDocumentIdentifier) {
        return {
            type: accountingDocumentIdentifier.type,
            number: accountingDocumentIdentifier.number,
            pointOfSale: accountingDocumentIdentifier.point_of_sale,
            numberWithPointOfSale: this.adaptNumberWithPointOfSale(
                accountingDocumentIdentifier.point_of_sale, accountingDocumentIdentifier.number),
            issueDate: accountingDocumentIdentifier.issue_date,
        }
    }

    adaptNumberWithPointOfSale(pointOfSale, number) {
        return new AccountingDocumentNumber(pointOfSale, number).shortened();
    }
}